import { __decorate, __metadata } from "tslib";
import { Debounce } from "lodash-decorators";
import { BehaviorSubject } from "rxjs";
import { ThemeBreakpointBoundaries } from "../../variables";
/**
 * A responsive breakpoint.
 * <br>Instances of this class can be compared.
 */
export class Breakpoint {
    constructor(
    /**
     * The name of the breakpoint
     */
    name, 
    /**
     * The minimum boundary of the breakpoint, in pixels
     */
    min, 
    /**
     * The maximum boundary of the breakpoint, in pixels
     */
    max) {
        this.name = name;
        this.min = min;
        this.max = max;
    }
    /**
     * The comparable value of the breakpoint.
     */
    valueOf() {
        return this.min;
    }
}
/**
 * Provides the current responsive breakpoint, as well as the supported breakpoints.
 * <br>Use the `default` accessor present on the constructor to access the singleton.
 */
export class BreakpointProvider {
    constructor() {
        this._breakpointsList = Object
            .entries(ThemeBreakpointBoundaries)
            .map(([key, value]) => new Breakpoint(key, value.min, value.max));
        this._breakpointsMap = this._breakpointsList.reduce((prev, curr) => {
            prev[curr.name] = curr;
            return prev;
        }, {});
        this._current$ = new BehaviorSubject(this.computeCurrentBreakpoint());
        window.addEventListener("resize", (ev) => this.onWindowResize(ev));
    }
    /**
     * Get the instance of the provider
     */
    static get default() {
        return BreakpointProvider._default = BreakpointProvider._default ?? new BreakpointProvider();
    }
    /**
     * All the supported breakpoints
     */
    get breakpoints() {
        return this._breakpointsMap;
    }
    /**
     * The current breakpoint
     */
    get current() {
        return this._current$.value;
    }
    /**
     * An observable value of the current breakpoint
     */
    get current$() {
        return this._current$;
    }
    computeCurrentBreakpoint() {
        const windowWidth = window.innerWidth;
        const current = this._breakpointsList.find(x => x.min <= windowWidth && (x.max == undefined || x.max >= windowWidth));
        return current;
    }
    onWindowResize(ev) {
        const current = this.computeCurrentBreakpoint();
        if (current != this.current) {
            this._current$.next(current);
        }
    }
}
__decorate([
    Debounce(500),
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [UIEvent]),
    __metadata("design:returntype", void 0)
], BreakpointProvider.prototype, "onWindowResize", null);
//# sourceMappingURL=BreakpointProvider.js.map